import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@15.5.19_@babel+core@7.29.7_react-dom@19.2.7_react@19.2.7__react@19.2.7_sass@1.77.4/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SeoKeywordProvider"] */ "/app/web/components/product-series/SeoKeywordProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ApplicationTemplate"] */ "/app/web/components/templates/ApplicationTemplate.tsx");
